export const SITE_URL = "https://coachingcraftersai.com";
export const SITE_NAME = "Coaching Crafters AI";
export const TAGLINE = "Achieving All Goals";

export const EMAILS = {
    info: "info@coachingcraftersai.com",
    sales: "sales@coachingcraftersai.com",
    support: "support@coachingcraftersai.com",
    privacy: "privacy@coachingcraftersai.com",
    grievance: "grievance@coachingcraftersai.com",
};

export const PHONE_PLACEHOLDER = "+91 XXXXX XXXXX";
export const BUSINESS_HOURS = "Mon–Sat, 10:00–19:00 IST";
export const ADDRESS = "4th Floor, Craftworks Tower, Hitech City, Hyderabad 500081, India";
export const LEGAL_ENTITY = "Sarvacharya Education Pvt Ltd";
